import React from "react";

import Stack from "@readai/pulse/components/Stack";

import ReadSmartSchedulerLogo from "../ReadSmartSchedulerLogo";

const EventNotification = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack
      spacing={3}
      justifyContent="space-between"
      sx={{ width: "500px", maxWidth: "100%", color: "text.default" }}
    >
      <ReadSmartSchedulerLogo />
      {children}
    </Stack>
  );
};

export default EventNotification;
